var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.17906 1.51531C0.0646128 2.66936 0.00730211 4.76226 1.00007 7.33571C1.98309 9.88391 3.96018 12.7931 6.7074 15.4461C9.45463 18.0991 12.4311 19.9734 15.012 20.8669C17.6186 21.7692 19.7082 21.6389 20.8226 20.4849C21.9371 19.3308 21.9944 17.2379 21.0016 14.6645C20.0186 12.1163 18.0415 9.20708 15.2943 6.55411C12.5471 3.90115 9.57061 2.0268 6.98966 1.13331C4.38313 0.230955 2.29351 0.361272 1.17906 1.51531ZM1.76397 7.04102C0.795058 4.52942 1.00847 2.87062 1.76803 2.08408C2.52759 1.29753 4.17793 1.02636 6.72181 1.90702C9.16678 2.75344 12.0441 4.55369 14.7255 7.14308C17.4069 9.73248 19.3065 12.5453 20.2377 14.9592C21.2066 17.4708 20.9932 19.1296 20.2337 19.9161C19.4741 20.7027 17.8238 20.9738 15.2799 20.0932C12.8349 19.2468 9.95756 17.4465 7.27617 14.8571C4.59477 12.2677 2.6952 9.45495 1.76397 7.04102Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9606 6.93443C20.9195 4.44869 20.6525 2.94498 20.0198 2.2898C19.3871 1.63462 17.8936 1.31528 15.3759 2.18688C12.9801 3.01627 10.1386 4.78973 7.48105 7.35612C4.82347 9.92251 2.95192 12.7004 2.03943 15.0658C1.0805 17.5515 1.34752 19.0552 1.98022 19.7104C2.61292 20.3656 4.10639 20.6849 6.62409 19.8133C9.01987 18.9839 11.8614 17.2105 14.519 14.6441C17.1765 12.0777 19.0481 9.29981 19.9606 6.93443ZM15.4992 15.6591C21.0412 10.3072 23.5196 3.8827 21.0348 1.30959C18.55 -1.26351 12.0429 0.989161 6.50083 6.34108C0.958758 11.693 -1.51964 18.1175 0.965181 20.6906C3.45 23.2637 9.95709 21.011 15.4992 15.6591Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.97363,
    y: 9.80005,
    width: 13.2,
    height: 13.2,
    rx: 6.6,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3351 18.5656H16.3868C17.4959 18.5656 18.4234 17.8772 18.4234 16.4048C18.4234 14.9324 17.5055 14.2344 16.3964 14.2344H15.3351V18.5656ZM16.4346 19.7895H14.0156V13.0106H16.4442C18.3756 13.0106 19.7906 14.2631 19.7906 16.4048C19.7906 18.5465 18.366 19.7895 16.4346 19.7895Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.01c4c4c12bf9830ac94cadf46d4d8fdd.svg";
export { ForwardRef as ReactComponent };